// Helpers for the "Visualize Elevation" node coloring.

// Reads a node's elevation (in meters), or null if unavailable.
// metric "ground" reads the terrain elevation from the props; "invert" reads
// the calculated invert elevation from the optimization result (calc).
export function getNodeElevation(element, metric = "ground") {
  const prop =
    metric === "invert"
      ? element?.calc?.find((p) => p.key === "invert_elevation")
      : element?.props?.find((p) => p.key === "elevation");
  if (!prop || prop.value === "" || prop.value == null) return null;
  const value = parseFloat(prop.value);
  return Number.isNaN(value) ? null : value;
}

// Computes the min/max elevation across all nodes, or null if no node has one.
export function getElevationRange(mapElements = [], metric = "ground") {
  let min = Infinity;
  let max = -Infinity;
  mapElements.forEach((element) => {
    if (element.type !== "node") return;
    const value = getNodeElevation(element, metric);
    if (value == null) return;
    if (value < min) min = value;
    if (value > max) max = value;
  });
  if (min === Infinity) return null;
  return { min, max };
}

// Maps an elevation value to a color: low = blue (hue 240) → high = red (hue 0).
export function elevationColor(value, min, max) {
  if (value == null || Number.isNaN(value)) return "#9e9e9e";
  const range = max - min;
  const t = range > 0 ? (value - min) / range : 0.5;
  const hue = (1 - t) * 240;
  return `hsl(${hue}, 85%, 45%)`;
}
